/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from 'reselect';

const getShareCalculatorConfig = (state: any) => state.getIn(['investmentCalculatorReducer', 'shareCalculatorConfig']);
const getShareCalculatorCustomerDetails = (state: any) => state.getIn(['investmentCalculatorReducer', 'shareWithCustomerDetails']);
const getShareBtnClicked = (state: any) => state.getIn(['investmentCalculatorReducer', 'shareCalcBtnClicked']);
const getShareBtn = (state: any) => state.getIn(['investmentCalculatorReducer', 'shareCalculatorImage']);
const getCustomerFromLink = (state: any) => state.getIn(['investmentCalculatorReducer', 'customerFromSharedLinkDetails']);
const getSipLumpsumCalculatorFormValues = (state: any) => state.getIn(['investmentCalculatorReducer', 'sipLumpsumCalculatorFormValues']);


const InvestmentCalculatorSelector = createSelector(
    [getShareCalculatorConfig, getShareCalculatorCustomerDetails, getShareBtnClicked, getShareBtn, getCustomerFromLink,getSipLumpsumCalculatorFormValues],
    (shareCalculatorConfig, shareWithCustomerDetails, shareCalcBtnClicked, shareCalculatorImage, customerFromSharedLinkDetails,sipLumpsumCalculatorFormValues) => ({
        shareCalculatorConfig, shareWithCustomerDetails, shareCalcBtnClicked, shareCalculatorImage, customerFromSharedLinkDetails,sipLumpsumCalculatorFormValues    })
);

export default InvestmentCalculatorSelector;